import PageHeader from 'components/PageHeader';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import FinancialConditionsTableWithFilters from './FinancialConditionsTable';

const FinancialConditionsPage = (): JSX.Element => {
    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader hostsList titleId={'financial-conditions.financial-conditions'} showBreadcrumb />
                <FinancialConditionsTableWithFilters />
            </div>
        </PaddedLayout>
    );
};

export default FinancialConditionsPage;
